export class NewsletterClass {
  constructor(
    public fname: string,
    public email: string
  ) {

  }
}
